var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditWithfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E2F0FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 25V20C11 17.7909 12.7909 16 15 16H25C27.2091 16 29 17.7909 29 20V25C29 27.2091 27.2091 29 25 29H15C12.7909 29 11 27.2091 11 25Z",
    fill: "#A2D0FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 16.5C28.7091 16.5 29 17.7909 29 20V25C29 27.2091 27.2091 29 25 29H15C12.7909 29 11 27.2091 11 25V20C11 17.7909 11.7909 16.5 14 16.5",
    stroke: "#005DAC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5387 20.8566L15.6964 24.2436L18.8491 22.9959C19.3966 22.7793 19.8627 22.397 20.1823 21.9024L25.9717 12.9436C26.395 12.2885 26.2071 11.4141 25.5519 10.9907L23.7303 9.81352C23.0751 9.39013 22.2007 9.57804 21.7773 10.2333L15.988 19.192C15.6684 19.6865 15.5113 20.2685 15.5387 20.8566Z",
    stroke: "#005DAC",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1173 12.1396L24.5048 14.3287",
    stroke: "#005DAC",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWithfile);
export default __webpack_public_path__ + "static/media/edit-withfile.b2ea2383e9156d4eca49952e182d5ded.svg";
export { ForwardRef as ReactComponent };